import { defaultOnError, useCosineMutation } from "./mutation"
import { cosineGet, cosinePost, ErrorCause } from "./default-query"
import { toast } from "sonner"

type CreateDemoProjectParams = {
  owner: string
  repo: string
  prompt?: string
  autopm?: boolean
}

type DemoTaskParams = {
  projectId: string
  projectName: string
  taskId: string
}

export const useCreateDemoProject = () => {
  return useCosineMutation<DemoTaskParams, CreateDemoProjectParams>({
    mutationFn: ({ owner, repo, prompt, autopm }) =>
      cosinePost(`/demo/project/${owner}/${repo}`, { prompt, autopm }),
  })
}

export const useCheckRepositoryExists = () => {
  return useCosineMutation<null, { owner: string; repo: string }>({
    mutationFn: ({ owner, repo }) => cosineGet(`/demo/exists/${owner}/${repo}`),
    showToast: false,
    onError: (error) => {
      const cause = error.cause as ErrorCause
      if (cause.status === 404) {
        return toast.error("Repository Not Found", {
          description: "Repository might not exist or is private!",
        })
      }
      return defaultOnError(error)
    },
  })
}

export const useJoinMailList = () => {
  return useCosineMutation<null, { email: string }>({
    mutationFn: ({ email }) => cosinePost(`/demo/join-mail-list`, { email }),
  })
}
